import React, { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { useToast, Spinner, ErrorBanner, EmptyState } from '../../components/ui';
import { fmt, daysOfCoverClass } from '../../utils/format';
import api from '../../utils/api';

export default function Forecast() {
  const [days, setDays] = useState(30);
  const [mode, setMode] = useState('prior_year');
  const { data, loading, error, refetch } = useFetch(`/api/forecast?days=${days}&mode=${mode}`, [days, mode]);
  const { showToast, Toast } = useToast();

  const createWO = async (productId) => {
    const qty = prompt('Quantity to produce?');
    if (!qty) return;
    try { await api.post('/api/work-orders', { productId, quantity: parseInt(qty) }); showToast('Work order created successfully'); }
    catch (err) { alert(err?.response?.data?.error || 'Failed'); }
  };

  if (loading) return <Spinner />;
  if (error) return <ErrorBanner message={error} onRetry={refetch} />;
  const isPriorYear = mode === 'prior_year';
  return (
    <div>

      <div className="page-header">
        <h1>Demand Forecast</h1>
        <div className="page-actions" style={{ display:'flex', gap:8, alignItems:'center' }}>
          <select value={mode} onChange={e => setMode(e.target.value)}>
            <option value="prior_year">Prior year same period</option>
            <option value="rolling">Last X days (rolling)</option>
          </select>
          <select value={days} onChange={e => setDays(Number(e.target.value))}>
            <option value={30}>30 days</option>
            <option value={60}>60 days</option>
            <option value={90}>90 days</option>
            <option value={120}>120 days</option>
          </select>
        </div>
      </div>

      {data?.rangeLabel && (
        <div style={{ fontSize:12, color:'var(--text-tertiary)', marginBottom:8 }}>
          <i className="ti ti-calendar" style={{ marginRight:4 }} />
          Based on sales from: <strong>{data.rangeLabel}</strong>
        </div>
      )}

      <div className="card" style={{ marginBottom:12 }}>
        <div className="card-title">Finished goods — {days}-day demand projection</div>
        <div className="table-wrap"><table>
          <thead><tr>
            <th>Product</th>
            <th>SKU</th>
            <th>On hand</th>
            {isPriorYear && <th>Units sold (prior year)</th>}
            <th>Projected demand</th>
            <th>Days cover</th>
            <th>Actions</th>
          </tr></thead>
          <tbody>{(data?.products||[]).map(p => (
            <tr key={p.id}>
              <td style={{ fontWeight:500 }}>{p.name}</td>
              <td style={{ fontFamily:'monospace', fontSize:12 }}>{p.sku}</td>
              <td>{p.quantity_on_hand}</td>
              {isPriorYear && <td style={{ color:'var(--text-tertiary)' }}>{parseInt(p.units_sold_in_lookback || 0)}</td>}
              <td>{p.projected_demand}</td>
              <td>
                {p.days_of_cover != null ? <span className={`badge ${daysOfCoverClass(p.days_of_cover)}`}>{p.days_of_cover}d</span> : <span className="text-muted">—</span>}
              </td>
              <td>
                {p.days_of_cover != null && p.days_of_cover < days &&
                  <button className="btn btn-sm btn-primary" onClick={() => createWO(p.id)}>Create WO</button>}
              </td>
            </tr>
          ))}</tbody>
        </table></div>
      </div>

      {data?.materialShortfalls?.length > 0 && (
        <div className="card">
          <div className="card-title">Raw material shortfalls</div>
          <div className="table-wrap"><table>
            <thead><tr><th>Material</th><th>On hand</th><th>Projected need</th><th>Shortfall</th><th>Vendor</th></tr></thead>
            <tbody>{data.materialShortfalls.map(m => (
              <tr key={m.id}>
                <td style={{ fontWeight:500 }}>{m.name}</td>
                <td>{m.quantity_on_hand} {m.unit_of_measure}</td>
                <td>{Number(m.projected_need).toFixed(2)}</td>
                <td><span className="badge badge-crit">{Number(m.shortfall).toFixed(2)}</span></td>
                <td style={{ fontSize:12 }}>{m.vendor_name || '—'}</td>
              </tr>
            ))}</tbody>
          </table></div>
        </div>
      )}
    </div>
  );
}
